import { Component, Input } from '@angular/core';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ActionItemInterface } from '../../../../../../coverpath-common/angular/interfaces/account-center/ActionItemInterface';
import type { CoverpathPolicy } from '../../../../../../coverpath-common/classes/coverpath_subclasses/CoverpathPolicy';
import { OnInit } from '@angular/core';

@Component({
  selector: 'exchange-1035-breakdown',
  moduleId: module.id,
  templateUrl: './exchange-1035-breakdown.component.html',
})
export class Exchange1035BreakdownComponent implements OnInit {
  @Input() actionItem: ActionItemInterface;

  private policy: CoverpathPolicy;
  amountTowardsPremium: number;
  amountTowardsAlir: number;
  transferAmount: number;
  fundsReceived: boolean;

  constructor(amorphicService: AmorphicService) {
    this.policy = amorphicService.controller.customer.application.primaryPolicy as CoverpathPolicy;
  }

  ngOnInit() {
    if (this.policy.alirRider && this.policy.alirRider.exchange1035) {
      const totalPremium = this.policy.premiumBreakdown.getTotalWithPendingAmendment();
      this.transferAmount = this.policy.alirRider.alir1035ExchangeAmountWithPendingAmendment();
      this.amountTowardsPremium = Math.min(totalPremium, this.transferAmount);
      this.amountTowardsAlir = Math.max(this.transferAmount - totalPremium, 0);
      this.fundsReceived = !!this.policy.alirRider.exchange1035.dateFundsReceived;
    }
  }
}
